import { render, staticRenderFns } from "./dataOverview.vue?vue&type=template&id=36ab6a27&scoped=true"
import script from "./dataOverview.vue?vue&type=script&lang=js"
export * from "./dataOverview.vue?vue&type=script&lang=js"
import style0 from "./dataOverview.vue?vue&type=style&index=0&id=36ab6a27&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_1f634a4a4b1fea536ed4e950e01c2669/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ab6a27",
  null
  
)

export default component.exports